import type { CompanySubscriptionResponse } from '../types';

/** What the server's state allows a company to START from here. Mirrors the server's own rules (a trial is once per
 * company and only before any paid subscription; checkout needs no active subscription) — the server still decides. */
export function startOptionsFor(subscription: CompanySubscriptionResponse | null): { trial: boolean; subscribe: boolean; changePlan: boolean; fixPaymentFirst: boolean } {
  const state = subscription?.effectiveState ?? 'NoSubscription';
  switch (state) {
    case 'NoSubscription':
    case 'TrialNotStarted':
      return { trial: true, subscribe: true, changePlan: false, fixPaymentFirst: false };
    case 'TrialActive':
    case 'TrialExpired':
    case 'Canceled':
      return { trial: false, subscribe: true, changePlan: false, fixPaymentFirst: false };
    case 'PastDueRestricted':
      return { trial: false, subscribe: false, changePlan: false, fixPaymentFirst: true };
    default:
      return { trial: false, subscribe: false, changePlan: true, fixPaymentFirst: false };
  }
}
